exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.add-contractor[data-v-fd77ccf8] {\n    display: block;\n    position: fixed;\n    right: 50px;\n    bottom: 15px;\n}\n", ""]);

// exports
